import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=a0dcb95a&"
import script from "./TableView.vue?vue&type=script&lang=js&"
export * from "./TableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports